import React, { useState, useEffect, Fragment } from 'react';
import {
  Link, withRouter, useParams, useLocation,
} from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Checkbox, Drawer, Tooltip, Button,
  Popover,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { LoadingOutlined, EditOutlined } from '@ant-design/icons';
import { QUANTITY } from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import './style.scss';
import closeIcon from '@Images/icons/icon-close-blue.png';
import MrpV2Actions from '@Actions/production/mrpV2Actions';
import ConvertToMo from '@Components/Sales/SalesOrder/ViewSalesOrder/ConvertToMo';
import loaderImg from '@Images/loader.gif';
import ReserveMrpStockItems from '../MaterialShortage/ReserveMrpStockItems';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';

function MaterialsRequirement({
  user, history, getProductionItems, getProductionItemsLoading, productionItems, getStockItems, getStockItemsSOLoading, stockItemsSO, mrpRuns, getProductionItemsSuccess, getStockItemsSuccess, pushToProductionItems, pushToProductionItemsLoading, pushToStockItems, pushToStockItemsLoading, updateMrpV2, updateMrpV2Loading, reserveShortageMrp, clearReservationLoading,
  moCreateCallback, updateMrpProduction, updateMrpProductionLoading, getMrpV2, match, mrpData, clearReservation, reserveShortageMrpLoading, call
}) {
  const [showConvertToMo, setShowConvertToMo] = useState(false);
  const [reserveDrawerOpen, setReserveDrawerOpen] = useState(false);
  const [order, setOrder] = useState(null);

  // Production Items
  const [selectedProductionItemRows, setSelectedProductionItemRows] = useState([]);
  const [selectedProductionItemRowKeys, setSelectedProductionItemRowKeys] = useState([]);
  const [callProdctionItem, setCallProdctionItem] = useState(false);
  const [consolidateProductionItems, setConsolidateProductionItems] = useState(false);
  const [ignoreProductionItemsAvailableStock, setIgnoreProductionItemsAvailableStock] = useState(false);
  const [ignoreProductionItemsReservedStock, setIgnoreProductionItemsReservedStock] = useState(false);

  // Stock Items
  const [selectedStockItemRows, setSelectedStockItemRows] = useState([]);
  const [selectedStockItemRowKeys, setSelectedStockItemRowKeys] = useState([]);
  const [callStockItem, setCallStockItem] = useState(false);
  const [consolidateStockItems, setConsolidateStockItems] = useState(false);
  const [ignoreStockItemsAvailableStock, setIgnoreStockItemsAvailableStock] = useState(false);
  const [ignoreStockItemsSafetyStock, setIgnoreStockItemsSafetyStock] = useState(false);
  const [ignoreStockItemsReservedStock, setIgnoreStockItemsReservedStock] = useState(false);

  const location = useLocation();
  // const { mrpId } = useParams();

  const mrpId = match.params?.mrpId;

  useEffect(() => {
    getMrpV2(
      {
        tenantId: mrpData?.tenant_id,
        listScreen: false,
        mrpId: Number(mrpId),
      }, (mrpV2Data) => {
        // Production Items
        setConsolidateProductionItems(mrpV2Data?.consolidate_requirement_mrp_production);
        setIgnoreProductionItemsAvailableStock(mrpV2Data?.ignore_available_stock_mrp_production);
        setIgnoreProductionItemsReservedStock(mrpV2Data?.ignore_reserved_stock_mrp_production);

        // Stock Items
        setConsolidateStockItems(mrpV2Data?.consolidate_requirement_mrp_stock_items);
        setIgnoreStockItemsAvailableStock(mrpV2Data?.ignore_available_stock_mrp_stock_items);
        setIgnoreStockItemsSafetyStock(mrpV2Data?.ignore_safety_stock_mrp_stock_items);
        setIgnoreStockItemsReservedStock(mrpV2Data?.ignore_reserved_stock_mrp_stock_items);
      },
    );

    const tab = location.search?.split('=')?.[1];
    if (tab === 'materials_requirement') {
      setCallProdctionItem(!callProdctionItem);
      setCallStockItem(!callStockItem);
    }
  }, [location.search, call]);

  useEffect(() => {
    if (Number(mrpId)) {
      getProductionItems(Number(mrpId));
    }
    return () => {
      getProductionItemsSuccess(null);
    };
  }, [callProdctionItem, mrpId]);

  useEffect(() => {
    const payload = {
      mrpId: Number(mrpId),
      entityType: 'SALES_ORDER',
    };
    getStockItems(payload);

    return () => {
      getStockItemsSuccess(null, 'SALES_ORDER');
    };
  }, [callStockItem]);

  const getProductionItemsColumns = () => {
    const mrpColumns = [
      {
        title: 'SKU#',
        fixed: 'left',
        width: '280px',
        render: (record) => (
          <Fragment>
            <div>
            <Popover 
              content={(
                <div style={{
                  maxHeight: '150px',
                  overflowY: 'auto',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  padding: '4px',
                }}
                >
                  {`${record?.internal_sku_code || ''} - ${record?.product_sku_name || ''}`}<br/>
                  {record?.lines[0]?.product_category_path?.length > 0 && (
                    <ProductCategoryLabel
                      categoryPath={record?.lines[0]?.product_category_path}
                      categoryName={record?.lines[0]?.product_category_path?.at(-1)}
                      containerStyle={{
                        width: "fit-content",
                      }}
                    />
                  )}
                </div>
              )}
              trigger="hover" 
              placement="bottomLeft"
            >
              {record?.product_sku_name ? (
                <div className="material-shortage-sku-name">
                  <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                    {`#${record?.internal_sku_code}`}
                  </Link>
                  <span>
                    {` - ${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`}
                  </span>
                </div>
              ) : '-'}
            </Popover>
            </div>
            {record?.order_id && (
              <div style={{ display: 'flex' }}>
                <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
                  {record?.sales_order_number}
                </Link>
              </div>
            )}
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'SO#',
        width: '280px',
        render: (record) => (
          <div style={{ width: '264px' }}>
            <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
              {record?.sales_order_number}
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Ordered',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.demand_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Fulfilled',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.invoiced_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserved',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={ignoreProductionItemsReservedStock ? 'strike-text' : ''}>
                {`${QUANTITY(record?.reserved_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              </div>
              {!consolidateProductionItems && (Number(record?.available_quantity) + Number(record?.reserved_quantity)) > 0 && (
                <div
                  className="material-requirement__reserve-button"
                  onClick={() => {
                    setReserveDrawerOpen(true);
                    setOrder(record);
                  }}
                >
                  <EditOutlined />
                </div>
              )}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Sent for Production',
        render: (record) => (
          <div style={{ minWidth: '120px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.created_mo_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Required',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>
              {`${QUANTITY(record?.shortage_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available Stock',
        render: (record) => (
          <div style={{ minWidth: '100px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div className={ignoreProductionItemsAvailableStock ? 'strike-text' : ''}>
              {`${QUANTITY(record?.available_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'To Be Produced',
        fixed: 'right',
        render: (record) => (
          <Fragment>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.pending_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return mrpColumns;
  };

  const getProductionItemsInnerColumns = () => {
    const mrpColumns = [
      {
        title: 'Order#',
        width: '96px',
        fixed: 'left',
        render: () => '',
      },
      {
        title: 'SO#',
        width: '280px',
        render: (record) => (
          <div style={{ width: '264px' }}>
            <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
              {record?.sales_order_number}
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Ordered',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.demand_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Fulfilled',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.invoiced_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserved',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className={ignoreProductionItemsReservedStock ? 'strike-text' : ''}>
                  {`${QUANTITY(record?.reserved_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
                </div>
                {(Number(record?.available_quantity) + Number(record?.reserved_quantity)) > 0 && (
                  <div
                    className="material-requirement__reserve-button"
                    onClick={() => {
                      setReserveDrawerOpen(true);
                      setOrder(record);
                    }}
                  >
                    <EditOutlined />
                  </div>
                )}
              </div>
            ) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Sent for Production',
        render: (record) => (
          <div style={{ minWidth: '120px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.created_mo_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Required',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>
              {`${QUANTITY(record?.shortage_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available Stock',
        render: (record) => <div style={{ minWidth: '100px' }}>-</div>,
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'To Be Produced',
        fixed: 'right',
        render: (record) => (
          <Fragment>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>
              {`${QUANTITY(record?.pending_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return mrpColumns;
  };

  const getStockItemsColumns = () => {
    const mrpColumns = [
      {
        title: 'padding',
        width: '95px',
        fixed: 'left',
        render: () => '',
      },
      {
        title: 'SKU#',
        fixed: 'left',
        width: '280px',
        render: (record) => (
          <Fragment>
            <div>
              <Popover 
              content={(
                <div style={{
                  maxHeight: '150px',
                  overflowY: 'auto',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  padding: '4px',
                }}
                >
                  {`${record?.internal_sku_code || ''} - ${record?.product_sku_name || ''}`}<br/>
                  {record?.lines[0]?.product_category_info?.category_path?.length > 0 && (
                    <ProductCategoryLabel
                      categoryPath={record?.lines[0]?.product_category_info?.category_path}
                      categoryName={record?.lines[0]?.product_category_info?.category_path?.at(-1)}
                      containerStyle={{
                        width: "fit-content",
                      }}
                    />
                  )}
                </div>
              )}
              trigger="hover" 
              placement="bottomLeft"
            >
              {record?.product_sku_name ? (
                <div className="material-shortage-sku-name">
                  <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                    {`#${record?.internal_sku_code}`}
                  </Link>
                  <span>
                    {` - ${record?.ref_product_code ? `${record?.ref_product_code} - ` : ''}${record?.product_sku_name}`}
                  </span>
                </div>
              ) : '-'}
            </Popover>
            </div>
            {record?.order_id && (
              <div style={{ display: 'flex' }}>
                <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
                  {record?.sales_order_number}
                </Link>
              </div>
            )}
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'SO#',
        width: '280px',
        render: (record) => (
          <div style={{ width: '264px' }}>
            <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
              {record?.sales_order_number}
            </Link>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Ordered',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.demand_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Fulfilled',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>{`${QUANTITY(record?.invoiced_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Reserved',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div className={ignoreStockItemsReservedStock ? 'strike-text' : ''}>
              {`${QUANTITY(record?.reserved_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Pending from Vendors',
        render: (record) => (
          <div style={{ minWidth: '120px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.created_mo_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Safety Stock',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div className={ignoreStockItemsSafetyStock ? 'strike-text' : ''}>
              {`${QUANTITY(record?.threshold_qty || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Required',
        render: (record) => (
          <div style={{ minWidth: '70px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>
              {`${QUANTITY(record?.shortage_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Available Stock',
        render: (record) => (
          <div style={{ minWidth: '100px' }}>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div className={ignoreStockItemsAvailableStock ? 'strike-text' : ''}>
              {record?.order_line_id ? '- ' : `${QUANTITY(record?.available_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
            </div>) : '-'}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'To Be Ordered',
        fixed: 'right',
        render: (record) => (
          <Fragment>
            {!['NON_STORABLE', 'SERVICE'].includes(record?.product_type) ? (<div>{`${QUANTITY(record?.pending_quantity || 0, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}</div>) : '-'}
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
    ];

    return mrpColumns;
  };

  const handleReserveProductionItems = (clear) => {
    const soIds = consolidateProductionItems ? selectedProductionItemRows?.map((item) => item?.lines?.map((line) => line?.order_line_id))?.flat() : selectedProductionItemRowKeys;

    const payload = {
      so_line_ids: soIds,
      mrp_id: mrpId,
      type: 'AVAILABLE_STOCK',
      sub_type: 'MRP_PRODUCTION',
    };

    if (clear) {
      clearReservation(payload, () => {
        setSelectedProductionItemRowKeys([]);
        setSelectedProductionItemRows([]);
        setCallProdctionItem(!callProdctionItem);
      });
    } else {
      reserveShortageMrp(payload, () => {
        setSelectedProductionItemRowKeys([]);
        setSelectedProductionItemRows([]);
        setCallProdctionItem(!callProdctionItem);
      });
    }
  };

  return (
    <Fragment>
      <Drawer
        onClose={() => setShowConvertToMo(false)}
        open={showConvertToMo}
        width="970px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '920px' }}>
            <H3Text text="Create Production Orders" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowConvertToMo(false)} />
          </div>
        </div>
        <ConvertToMo
          selectedRows={selectedProductionItemRows}
          inputTenant={mrpData?.tenant_id}
          callback={() => {
            setShowConvertToMo(false);
            setCallProdctionItem(!callProdctionItem);
            setCallStockItem(!callStockItem);
            moCreateCallback();
            setSelectedProductionItemRows([]);
            setSelectedProductionItemRowKeys([]);
          }}
          isMrp
          consolidateProductionItems={consolidateProductionItems}
          mrpId={mrpId}
        />
      </Drawer>
      <Drawer
        onClose={() => setReserveDrawerOpen(false)}
        open={reserveDrawerOpen}
        width="970px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '920px' }}>
            <H3Text text="Reservation" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setReserveDrawerOpen(false);
                setCallProdctionItem(!callProdctionItem);
              }}
            />
          </div>
        </div>
        <ReserveMrpStockItems
          order={order}
          callback={() => {
            setReserveDrawerOpen(false);
            setCallProdctionItem(!callProdctionItem);
          }}
          mrpId={mrpId}
        />
      </Drawer>
      <div className="material-requirement__wrapper">
        <div className="material-requirement__upper-wrapper">
          <div className="material-requirement__table">
            <div className="flex-display">
              <div className="material-requirement__table-title__button-wrapper">
                <Button
                  type="primary"
                  onClick={() => {
                    setShowConvertToMo(true);
                  }}
                  disabled={selectedProductionItemRows?.length === 0}
                >
                  Send for Production
                </Button>
                &nbsp;&nbsp;
                <Button
                  type="primary"
                  onClick={() => {
                    handleReserveProductionItems(false);
                  }}
                  disabled={selectedProductionItemRows?.length === 0}
                  loading={reserveShortageMrpLoading}
                >
                  Reserve Stock
                </Button>
                &nbsp;&nbsp;
                <Button
                  danger
                  onClick={() => {
                    handleReserveProductionItems(true);
                  }}
                  disabled={selectedProductionItemRows?.length === 0}
                  loading={clearReservationLoading}
                >
                  Clear Reserved Stock
                </Button>
                &nbsp;&nbsp;
                <Button
                  onClick={() => {
                    pushToStockItems({
                      mrp_id: mrpId,
                      order_line_ids: consolidateProductionItems ? selectedProductionItemRows?.map((item) => item?.lines?.map((line) => line?.order_line_id))?.flat() : selectedProductionItemRowKeys,
                    }, () => {
                      setCallProdctionItem(!callProdctionItem);
                      setCallStockItem(!callStockItem);
                      setSelectedProductionItemRowKeys([]);
                      setSelectedStockItemRowKeys([]);
                      setSelectedProductionItemRows([]);
                    });
                  }}
                  disabled={selectedProductionItemRows?.length === 0}
                >
                  Add to Purchase
                </Button>
                &nbsp;&nbsp;

                {
                  productionItems?.data && (getProductionItemsLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading)
                  && <H3Image src={loaderImg} className="table-mini-loader" />
                }
              </div>
            </div>
            <Table
              key={1}
              title={() => (
                <div className="material-requirement__table-title__wrapper">
                  <div className="material-requirement__table-title-count">
                    {productionItems?.data?.length || '0'}
                  </div>
                  Items with Bill of Materials
                  <div className="material-requirement__checkbox-wrapper">
                    <div className="flex-display">
                      <div>
                        <Checkbox
                            checked={ignoreProductionItemsAvailableStock}
                            onChange={(e) => {
                              setIgnoreProductionItemsAvailableStock(e.target.checked);
                              setSelectedProductionItemRowKeys(null);
                              setSelectedProductionItemRows(null);
                              updateMrpV2({
                                mrp_id: mrpId,
                                ignore_available_stock_mrp_production: e.target.checked,
                              }, () => setCallProdctionItem(!callProdctionItem));
                            }}
                        >
                          Ignore Available Stock
                        </Checkbox>
                      </div>
                      <div>
                        <Checkbox
                            checked={ignoreProductionItemsReservedStock}
                            onChange={(e) => {
                              setIgnoreProductionItemsReservedStock(e.target.checked);
                              setSelectedProductionItemRowKeys(null);
                              setSelectedProductionItemRows(null);
                              updateMrpV2({
                                mrp_id: mrpId,
                                ignore_reserved_stock_mrp_production: e.target.checked,
                              }, () => setCallProdctionItem(!callProdctionItem));
                            }}
                        >
                          Ignore Reserved Stock
                        </Checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              bordered
              loading={!productionItems?.data && (getProductionItemsLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading)}
              showHeader
              size="small"
              scroll={{ x: 'max-content' }}
              columns={consolidateProductionItems ? getProductionItemsColumns()?.filter((item) => !['SO#']?.includes(item.title)) : getProductionItemsColumns()?.filter((item) => !['SO#']?.includes(item.title))}
              dataSource={productionItems?.data ? productionItems?.data?.sort((a, b) => (b.pending_quantity - a.pending_quantity))?.map((item) => ({
                ...item,
                key: consolidateProductionItems ? item?.product_sku_id : (item?.order_line_id || item?.mo_fg_id),
              })) : []}
              pagination={false}
              rowSelection={(window.screen.width > 425) ? {
                onChange: (rowKeys, rows) => {
                  setSelectedProductionItemRowKeys(rowKeys);
                  setSelectedProductionItemRows(rows);
                },
                selectedRowKeys: selectedProductionItemRowKeys,
                getCheckboxProps: (record) => ({
                  disabled: ['NON_STORABLE', 'SERVICE'].includes(record?.product_type),
                }),
              } : false}
              rowClassName={(rec) => (rec?.pending_quantity <= 0 ? '' : 'material-requirement__short-row')}
              expandable={consolidateProductionItems ? {
                expandedRowRender: (record) => (
                  <Table
                    bordered
                    size="small"
                    scroll={{ x: 'max-content' }}
                    columns={getProductionItemsInnerColumns()?.filter((item) => !['SKU#'].includes(item.title))}
                    dataSource={record?.lines ? record?.lines?.sort((a, b) => (b.pending_quantity - a.pending_quantity))?.map((item) => ({
                      ...item,
                      key: item?.order_line_id,
                    })) : []}
                    pagination={false}
                  />
                ),
                rowExpandable: (record) => record?.lines?.length > 0,
              } : false}
            />
          </div>
        </div>
        <div className="material-requirement__lower-wrapper">
          <div className="material-requirement__table">
            <div className="material-requirement__table-title__button-wrapper">
              <Button
                type="primary"
                onClick={() => {
                  pushToProductionItems({
                    mrp_id: mrpId,
                    order_line_ids: consolidateStockItems ? selectedStockItemRows?.map((item) => item?.lines?.map((line) => line?.order_line_id))?.flat() : selectedStockItemRowKeys,
                  }, () => {
                    setSelectedProductionItemRowKeys([]);
                    setSelectedProductionItemRows([]);
                    setSelectedStockItemRowKeys([]);
                    setSelectedProductionItemRows([]);
                    setCallProdctionItem(!callProdctionItem);
                    setCallStockItem(!callStockItem);
                  });
                }}
                disabled={selectedStockItemRowKeys?.length === 0}
              >
                Add to Production List
              </Button>
              &nbsp;
              {
                stockItemsSO?.data && (getStockItemsSOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading)
                && <H3Image src={loaderImg} className="table-mini-loader" />
              }
            </div>
            <Table
              key={2}
              title={() => (
                <div className="material-requirement__table-title__wrapper">
                  <div className="material-requirement__table-title-count">{stockItemsSO?.data?.length || '0'}</div>
                  Items Without Bill of Materials
                  <div className="material-requirement__checkbox-wrapper">
                    <div className="flex-display">
                      <div>
                        <Checkbox
                            checked={ignoreStockItemsAvailableStock}
                            onChange={(e) => {
                              setIgnoreStockItemsAvailableStock(e.target.checked);
                              setSelectedStockItemRowKeys([]);
                              setSelectedStockItemRows([]);
                              updateMrpV2({
                                mrp_id: mrpId,
                                ignore_available_stock_mrp_stock_items: e.target.checked,
                              }, () => setCallStockItem(!callStockItem));
                            }}
                        >
                          Ignore Available Stock
                        </Checkbox>
                      </div>
                      <div>
                        <Checkbox
                            checked={ignoreStockItemsSafetyStock}
                            onChange={(e) => {
                              setIgnoreStockItemsSafetyStock(e.target.checked);
                              setSelectedStockItemRowKeys([]);
                              setSelectedStockItemRows([]);
                              updateMrpV2({
                                mrp_id: mrpId,
                                ignore_safety_stock_mrp_stock_items: e.target.checked,
                              }, () => setCallStockItem(!callStockItem));
                            }}
                        >
                          Ignore Safety Stock
                        </Checkbox>
                      </div>
                      <div>
                        <Checkbox
                            checked={ignoreStockItemsReservedStock}
                            onChange={(e) => {
                              setIgnoreStockItemsReservedStock(e.target.checked);
                              updateMrpV2({
                                mrp_id: mrpId,
                                ignore_reserved_stock_mrp_stock_items: e.target.checked,
                              }, () => setCallStockItem(!callStockItem));
                            }}
                        >
                          Ignore Reserved Stock
                        </Checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              bordered
              loading={!stockItemsSO?.data && (getStockItemsSOLoading || pushToProductionItemsLoading || pushToStockItemsLoading || updateMrpV2Loading)}
              showHeader
              size="small"
              scroll={{ x: 'max-content' }}
              columns={getStockItemsColumns()?.filter((item) => !['SO#', 'padding'].includes(item.title))}
              dataSource={stockItemsSO?.data ? stockItemsSO?.data?.map((item) => ({
                ...item,
                key: consolidateStockItems ? item?.product_sku_id : (item?.order_line_id || item?.mo_line_id),
              })) : []}
              pagination={false}
              rowSelection={(window.screen.width > 425) ? {
                onChange: (rowKeys, rows) => {
                  setSelectedStockItemRowKeys(rowKeys);
                  setSelectedStockItemRows(rows);
                },
                selectedStockItemRowKeys,
                getCheckboxProps: (record) => ({
                  disabled: record?.bom_list === null || ['NON_STORABLE', 'SERVICE'].includes(record?.product_type),
                }),
              } : false}
              rowClassName={(rec) => (rec?.is_material_available ? '' : 'material-requirement__short-row')}
              expandable={consolidateStockItems && {
                expandedRowRender: (record) => (
                  <Table
                    bordered
                    size="small"
                    scroll={{ x: 'max-content' }}
                    columns={getStockItemsColumns()?.filter((item) => !['SKU#'].includes(item.title))}
                    dataSource={record?.lines ? record?.lines?.map((item) => ({
                      ...item,
                      key: item?.order_line_id,
                    })) : []}
                    pagination={false}
                  />
                ),
                rowExpandable: (record) => record?.lines?.length > 0,
              }}
            />
          </div>
        </div>

      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, MrpV2Reducers,
}) => ({
  user: UserReducers.user,
  getProductionItemsLoading: MrpV2Reducers.getProductionItemsLoading,
  pushToProductionItemsLoading: MrpV2Reducers.pushToProductionItemsLoading,
  getStockItemsSOLoading: MrpV2Reducers.getStockItemsSOLoading,
  pushToStockItemsLoading: MrpV2Reducers.pushToStockItemsLoading,
  updateMrpV2Loading: MrpV2Reducers.updateMrpV2Loading,
  productionItems: MrpV2Reducers.productionItems,
  stockItemsSO: MrpV2Reducers.stockItemsSO,
  updateMrpProductionLoading: MrpV2Reducers.updateMrpProductionLoading,
  getMrpV2Loading: MrpV2Reducers.getMrpV2Loading,
  mrpV2: MrpV2Reducers.mrpV2,
  clearReservationLoading: MrpV2Reducers.clearReservationLoading,
  reserveShortageMrpLoading: MrpV2Reducers.reserveShortageMrpLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getMrpV2: (payload, callback) => dispatch(MrpV2Actions.getMrpV2(payload, callback)),
  getProductionItems: (mrpId, callback) => dispatch(MrpV2Actions.getProductionItems(mrpId, callback)),
  getProductionItemsSuccess: (productionItems) => dispatch(MrpV2Actions.getProductionItemsSuccess(productionItems)),
  getStockItems: (payload, callback) => dispatch(MrpV2Actions.getStockItems(payload, callback)),
  getStockItemsSuccess: (stockItemsSO, entityType) => dispatch(MrpV2Actions.getStockItemsSuccess(stockItemsSO, entityType)),
  pushToProductionItems: (payload, callback) => dispatch(MrpV2Actions.pushToProductionItems(payload, callback)),
  pushToStockItems: (payload, callback) => dispatch(MrpV2Actions.pushToStockItems(payload, callback)),
  updateMrpV2: (payload, callback) => dispatch(MrpV2Actions.updateMrpV2(payload, callback)),
  updateMrpProduction: (payload, callback) => dispatch(MrpV2Actions.updateMrpProduction(payload, callback)),
  reserveShortageMrp: (payload, callback) => dispatch(MrpV2Actions.reserveShortageMrp(payload, callback)),
  clearReservation: (payload, callback) => dispatch(MrpV2Actions.clearReservation(payload, callback)),
});

MaterialsRequirement.propTypes = {
  user: PropTypes.any,
  productionItems: PropTypes.any,
  stockItemsSO: PropTypes.any,
  getProductionItems: PropTypes.func,
  getStockItems: PropTypes.func,
  getProductionItemsLoading: PropTypes.bool,
  getStockItemsSOLoading: PropTypes.bool,
  getMrpV2: PropTypes.func,
  getMrpV2Loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MaterialsRequirement));
